import React from 'react';

type StructuredDataProps = {
  data: object;
};

export default function StructuredData({ data }: StructuredDataProps): React.ReactElement {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

